import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=474ddf8a&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=474ddf8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474ddf8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('474ddf8a')) {
      api.createRecord('474ddf8a', component.options)
    } else {
      api.reload('474ddf8a', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=474ddf8a&scoped=true&", function () {
      api.rerender('474ddf8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Ym7jp5qO0h0j/JS/comp/DocBox.vue"
export default component.exports